import { render, staticRenderFns } from "./ListFaq.vue?vue&type=template&id=56621c75"
import script from "./ListFaq.vue?vue&type=script&lang=js"
export * from "./ListFaq.vue?vue&type=script&lang=js"
import style0 from "./ListFaq.vue?vue&type=style&index=0&id=56621c75&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports